import _get from 'lodash/get';
import _set from 'lodash/set';

/**
 * Updates the Adobe DataLayer 'page.pageInfo'.
 * @param {string} auxiliary - Auxiliary result
 * @param {string} pageName - Page name assigned to an app (e.g. 'Profile')
 */
function setPageTags({ auxiliary, pageName }) {
  if (!_get(auxiliary, 'data.xref.xid') || !pageName) return;

  const dataStore = {
    pageName: {
      path: 'digitalData.page.pageInfo.pageName',
      value: _get(window, 'digitalData.page.pageInfo.pageName', '').trim()
    },
    securityName: _get(auxiliary, 'data.xref.name', '').trim(),
    securitySymbol: _get(auxiliary, 'data.xref.symbol', '').trim(),
    securityType: _get(auxiliary, 'data.fundType', '').trim(),
    tags: {
      path: 'digitalData.page.attributes.tags',
      value: _get(window, 'digitalData.page.attributes.tags', {})
    }
  };

  const formattedSecurityType = dataStore.securityType.replace(/\s/g, '');
  const formattedPageName = formattedSecurityType ? `${formattedSecurityType}_${pageName}` : `${pageName}`;

  // Public and Integrated Environments - Public and eventually Secure integrated environments should provide
  // an initialized Adobe Data Layer.
  if (dataStore.pageName.value.match(/x{3}/i)) {
    const value = dataStore.pageName.value.replace(/x{3}/i, `${formattedPageName}`);
    _set(window, dataStore.pageName.path, value);
  }

  // Secure or Non-Integrated - As of 05/05/2021 these environments are not initalizing the Adobe Data Layer.
  // So plugging in a place holder value with an unknown fat wire asset id.
  if (!dataStore.pageName.value && pageName === 'Profile') {
    const value = `_PG_InvestPerform_${formattedPageName}`;
    _set(window, dataStore.pageName.path, value);
  }

  _set(window, dataStore.tags.path, {
    tickersymbol: dataStore.securitySymbol, // eVar27
    tickerfundname: dataStore.securityName, // eVar28
    fundtypeprofile: dataStore.securityType // eVar30
  });
}

/**
 * Updates the Adobe DataLayer 'page.pageInfo' for the screener page
 * @param {string} pageName - Page name assigned to an app
 */
function setScreenerPageTags({ pageName }) {
  if (!pageName) return;

  const dataStore = {
    pageName: {
      path: 'digitalData.page.pageInfo.pageName'
    }
  };

  // Public and Integrated Environments - Public and eventually Secure integrated environments should provide
  // an initialized Adobe Data Layer.
  _set(window, dataStore.pageName.path, `${pageName}`);

}

const adobeAnalytics = {
  setScreenerPageTags,
  setPageTags
};

export default adobeAnalytics;
